import axios from 'axios';
import _ from 'lodash';

// initial state
const state = () => ({
    list: [],
    loading: false,
    saving: false,
    allLoaded: false,
})

// getters
const getters = {

}

// actions
const actions = {
    async load({commit, state, rootState}, kooiid){
        commit("isLoading", true);
        await axios.get(rootState.settings.url + "/api/v1/" + rootState.settings.internal.user_company + "/notes/" + kooiid).then(response =>{
            commit("set", response.data.data);
        })
        commit("isLoading", false);
    },
    async company_load({commit, state, rootState}, id){
        commit("isLoading", true);
        await axios.get(rootState.settings.url + "/api/v1/" + rootState.settings.internal.user_company + "/company_notes/" + id).then(response =>{
            commit("set", response.data.data);
        })
        commit("isLoading", false);
    },
    async store({commit, state, rootState}, data){
        commit("isSaving", true);
        if(data.kooi_id){
            await axios.post(rootState.settings.url + "/api/v1/" + rootState.settings.internal.user_company + "/notes", data.data).then(response =>{
                commit("unshift", response.data.data);
            })
        }
        if(data.company_id){
            await axios.post(rootState.settings.url + "/api/v1/" + rootState.settings.internal.user_company + "/notes", data.data).then(response =>{
                commit("unshift", response.data.data);
            })
        }

        commit("isSaving", false);
    },
    async update({commit, state, rootState}, data){
        commit("isSaving", true);
        await axios.put(rootState.settings.url + "/api/v1/" + rootState.settings.internal.user_company + "/notes/" + data.id, data).then(response => {

        })
        commit("isSaving", false);
    },
    async destroy({commit, state, rootState}, data){
        commit('isSaving', true);
        await axios.delete(rootState.settings.url + "/api/v1/" + rootState.settings.internal.user_company + "/notes/" + data.id).then(response => {
            commit("removeId", response.data.deleted);
        })
        commit('isSaving', false);
    }
}

// mutations
const mutations = {
    clean(state){
        state.list = [];
        state.loading = false;
        state.saving = false;
      },
    isSaving(state, status){
        state.saving = status;
    },
    isLoading(state, status){
        state.loading = status;
    },
    set(state, list){
        if(list == undefined || list.length <= 0){
            state.allLoaded = true;
            state.list = [];
        }
        else {
            state.list = list;
        }
    },
    unshift(state, element){
        var index = state.list.findIndex(item => item.id == element.id);
        if(index > -1){
            state.list[index] = element;
        }else{
            state.list.unshift(element);
        }
    },
    removeId(state, id){
        var index = state.list.findIndex(item => item.id == id);
        if(index >= 0){
            state.list.splice(index, 1);
        }
    },
    upadteOrCreate(state, data){
        var index = state.list.findIndex(item => item.id == data.id);
        if(index > -1){
            state.list[index] = data;
        }else{
            state.list.unshift(data);
        }
    },
    delete(state, data){
        var index = state.list.findIndex(item => item.id == data.id);
        if(index >= 0){
            state.list.splice(index, 1);
        }
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
    modules: {
    }
}
